import { render, staticRenderFns } from "./EditUserProfile.vue?vue&type=template&id=1d636cd6&scoped=true&"
import script from "./EditUserProfile.vue?vue&type=script&lang=js&"
export * from "./EditUserProfile.vue?vue&type=script&lang=js&"
import style0 from "./EditUserProfile.vue?vue&type=style&index=0&id=1d636cd6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d636cd6",
  null
  
)

export default component.exports